"use client";
import { Text } from "@/components/ui/Text";
import { ChevronRight } from "lucide-react";
import cn from "twsx";
import styles from "./List.module.css";

function DisclosureTriangle({ collapsed }: { collapsed: boolean }) {
  return <ChevronRight aria-hidden="true" className={cn("size-3.5 shrink-0 text-text-tertiary", collapsed ? "rotate-0" : "rotate-90")} />;
}

export function ListGroupHeader({
  label,
  count,
  collapsed,
  onToggle,
  hasSelectionColumn,
  pinLabelOnHorizontalScroll,
  nested = false,
}: {
  label: string;
  count: number;
  collapsed: boolean;
  onToggle: () => void;
  hasSelectionColumn: boolean;
  pinLabelOnHorizontalScroll: boolean;
  nested?: boolean;
}) {
  return (
    <button
      type="button"
      data-list-group-header="true"
      aria-expanded={!collapsed}
      onClick={onToggle}
      className={cn(
        "relative col-span-full grid list-table-subgrid h-row-group w-full items-center rounded-kbd bg-bg-surface text-left",
        "outline-none hover:bg-fill-hover",
        "focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-accent",
      )}
    >
      {hasSelectionColumn && (
        <span className={cn(styles.groupToggle, "col-start-1 flex h-full items-center justify-center")} data-nested={nested || undefined}>
          <DisclosureTriangle collapsed={collapsed} />
        </span>
      )}
      <span
        className={cn(styles.groupLabel, "flex min-w-0 items-center pe-2", hasSelectionColumn ? "col-start-2 -col-end-1" : "col-span-full")}
        data-nested={nested || undefined}
        data-pinned={pinLabelOnHorizontalScroll || undefined}
      >
        {!hasSelectionColumn && (
          <span className="absolute -left-5 flex shrink-0">
            <DisclosureTriangle collapsed={collapsed} />
          </span>
        )}
        <Text weight="medium" tone="secondary" truncate>{label}</Text>
        <Text data-list-group-count="true" size="sm" tone="tertiary" numeric className="ml-2 shrink-0">{count}</Text>
      </span>
    </button>
  );
}
